import { isValid, parse } from "date-fns";
import { format, toZonedTime } from "date-fns-tz";

export const DATE_TIME_FORMAT = "yyyy-MM-dd HH:mm";
export const DATE_FORMAT = "yyyy-MM-dd";
export const STANDARD_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const DATE_MONTH_FORMAT = "dd/MM";
export const DATE_FORMAT_WITH_SLASH = "dd/MM/yyyy";

export const MASK_DATE_TIME_FORMAT = "####-##-## ##:##";
export const MASK_DATE_FORMAT = "####-##-##";

export const TIME_FORMAT = "HH:mm";
export const DATE_PICKER_DATE_FORMAT = "yyyy-MM-dd";
export const DATE_TIME_MASKED_FORMAT = "yyyyMMddHHmm";
export const TIME_ZONE = "Pacific/Auckland";
export const DATE_PICKER_DATE__MONTH_FIRST_FORMAT = "MM-dd-yyyy";

export function formatDate(val: Date, stringFormat = DATE_FORMAT) {
  if (isValid(val)) {
    return format(val, stringFormat);
  }
  throw "Unable to format date";
}

export function parseDatetime(val: string, stringFormat = DATE_TIME_FORMAT) {
  return toZonedTime(parse(val, stringFormat, new Date()), TIME_ZONE);
}

export function isValidMaskedDateTime(
  val: string,
  stringFormat = DATE_TIME_FORMAT,
) {
  let date: Date;

  if (val.length === stringFormat.length) {
    date = parse(val, stringFormat, new Date());
  } else if (val !== "Invalid Date") {
    date = parse(val, stringFormat, new Date());
  } else {
    return false;
  }

  return date && isValid(date);
}

export function formatDateTimeToMasked(
  val: Date,
  stringFormat = DATE_TIME_MASKED_FORMAT,
) {
  return formatDate(val, stringFormat);
}
